import { FormattedMessage } from 'react-intl';

const InvalidPostalCode = (): JSX.Element => {
  return (
    <FormattedMessage
      id="account_v2.components.form_errors.invalid_postal_code.number"
      defaultMessage="Use at least one number"
    />
  );
};

export default InvalidPostalCode;
